import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  StructurePredictionModel,
  getModelDisplayName,
} from 'molbio/proteins/util/StructurePredictionConstants';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {GRAY_DARKER} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

const MODEL_LINKS: Record<StructurePredictionModel, string> = {
  [StructurePredictionModel.ALPHAFOLD]: 'https://deepmind.google/science/alphafold/',
  [StructurePredictionModel.CHAI1]: 'https://www.chaidiscovery.com/news/introducing-chai-1',
};

interface ModelSelectorProps {
  selectedModel: StructurePredictionModel;
  onModelChange: (model: StructurePredictionModel) => void;
  disabled?: boolean;
  className?: string;
}

export default function ModelSelector({
  selectedModel,
  onModelChange,
  disabled = false,
  className,
}: ModelSelectorProps): JSX.Element {
  return (
    <div className={className}>
      <div className={css(styles.label)}>Model</div>
      <SelectDropdown
        displayName={getModelDisplayName(selectedModel)}
        disabled={disabled}
        menu={
          <Menu width={MenuWidth.FULL} value={selectedModel}>
            {Object.values(StructurePredictionModel).map((model) => (
              <Option
                key={model}
                value={model}
                onSelect={() => {
                  onModelChange(model);
                }}
              >
                {getModelDisplayName(model)}
              </Option>
            ))}
          </Menu>
        }
      />
      <div className={css(styles.linkContainer)}>
        <a
          href={MODEL_LINKS[selectedModel]}
          target="_blank"
          rel="noopener noreferrer"
          className={css(styles.modelLink)}
        >
          Learn more about {getModelDisplayName(selectedModel)}
        </a>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  label: {
    ...FONT_PROXIMA_13,
    fontWeight: 600,
    marginBottom: '6px',
    color: GRAY_DARKER,
  },
  linkContainer: {
    marginTop: '8px',
  },
  modelLink: {
    ...FONT_PROXIMA_13,
    color: '#0066cc',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

export {MODEL_LINKS};
